import { EuiSpacer } from '@elastic/eui';
import VideoCard from 'components/Quick_Installation/Videos/video-wps-d-link';
import NavButtons from 'components/Quick_Installation/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  VideoCard,
  NavButtons,
  BreadCrumbs,
  SEOHelmet,
  React
};